import { render, staticRenderFns } from "./UserDelete.vue?vue&type=template&id=65c490e4&"
import script from "./UserDelete.vue?vue&type=script&lang=ts&"
export * from "./UserDelete.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports